/**
 * Método que retorna el index del trámite dentro del catálogo trámites
 * @param {Number} idTramite 
 * @param {Array<object>} tramites 
 * @returns Number
 */
export const buscarTramiteIndex = (idTramite, tramites) => {
    for (let i = 0; i < tramites.length; i++) {
        if (Number(idTramite) === tramites[i].idTramite) return i;
    }
    return 0;
}